module.exports = __webpack_public_path__ + "static/flags/SY-28a0464547557256d9924627890cba7e.gif";